import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import CountryFilter from "../Filters/CountryFilter";
import WorkTypeFilter from "../Filters/WorkTypeFilter";
import CityFilter from "../Filters/CityFilter";
import { Modal } from "react-bootstrap";
import ListOfBidModel from "./ListOfBidModel";
import ViewPlanHolderModel from "./ViewPlanHolderModel";
import OptInModel from "./OptInModel";
import SeeRecordsModel from "./SeeRecordsModel";
import AdvertiseForHelpModel from "./AdvertiseForHelpModel";
import PrimeContractorHelpModel from "./PrimeContractorHelpModel";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
import favoriteImg from "../../assets/bookmark-favorite.svg";
import loader from "../../assets/loader.svg";

export default function ShowFavoritesModal({
  open,
  handleModalClose,
  type,
  data,
  handleAPIcall,
}) {
 
  const [StateListFromLocalStorage, setStateListFromLocalStorage] = useState(
    []
  );
  const [storedState, setstoredState] = useState(
    JSON.parse(localStorage.getItem("selectedState"))
  );
  const [selectedState, setSelectedState] = useState();

  const [modelOpen, setModelOpen] = useState(false);
  const [modelOpenViewPlan, setModdelOpenViewPlan] = useState(false);
  const [modelOpenOptIN, setModelOpenOptIN] = useState(false);
  const [modelSeeRecords, setModelSeeRecords] = useState(false);
  const [modelAdvertiseForHelp, setModelAdvertiseForHelp] = useState(false);
  const [PrimeContractorHelp, setModelPrimeContractorHelp] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [selectedCcnCallId, setSelectedCcnCallId] = useState("");
  const [favloader, setFavloader] = useState(false);

  const design_build_category_options = [
    { value: "DESIGN_BUILD_MRB", label: "MRB" },
    { value: "DESIGN_BUILD_WAH", label: "WAH" },
    { value: "DESIGN_BUILD_WAYBAY", label: "BAYWAY" },
  ];

  const getStoredUserInfo = () => {
    const storedData = localStorage.getItem("loggedInUserInfo");
    return storedData ? JSON.parse(storedData) : {};
  };

  const getArrayOfSelectedWorkTypes = (workTypeString) => {
    return workTypeString
      ? workTypeString.split(",").map((item) => item.trim())
      : [];
  };
  const init = {
    project_id: data.id,
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    date_submitting: data.estimated_end_date,
    dbe_goal: data.dbe_goal,
    project_title: data.project_title,
    project_description: data.project_description,
    project_page_type: data.page_type,
    design_build_category: data.design_build_category,
    worktypes: { highway: getArrayOfSelectedWorkTypes(data.worktypes) },
    county: "",
    state_id: "",
    file: null,
    city: data.city,
    download_url: data.download_url,
  };

  useEffect(() => {
    const userInfo = getStoredUserInfo();

    setFormData((prevState) => ({
      ...prevState,
      first_name: userInfo.first_name || "",
      last_name: userInfo.last_name || "",
      email: userInfo.email || "",
      phone_number: userInfo.phone_number || "",
    }));
  }, []);

  const [formData, setFormData] = useState(init);

  useEffect(() => {
    let state = "";
    if (selectedState) {
      state = selectedState;
    } else {
      state = storedState;
    }
  }, [selectedState, storedState]);

  const parseDateFromString = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const paddedMonth = String(month).padStart(2, "0");
    const paddedDay = String(day).padStart(2, "0");
    return `${paddedMonth}-${paddedDay}-${year}`;
  };

  const handleModelOpen = (callId) => {
    setSelectedData(callId);
    setModelOpen(true);
  };
  const handleModelOpenViewPlan = (callId) => {
    setSelectedData(callId);
    setModdelOpenViewPlan(true);
  };
  const handleModelOpenOptIN = (callid, ccnCallId) => {
 

    setSelectedData(callid);
    setSelectedCcnCallId(ccnCallId);
    setModelOpenOptIN(true);
  };
  const handleModelOpenSeeRecords = (callid, ccnCallId) => {
    setSelectedData(callid);
    setSelectedCcnCallId(ccnCallId);
    setModelSeeRecords(true);
  };
  const handleModelOpenAdvertiseForHelp = (callId, ccnCallId) => {
    setModelAdvertiseForHelp(true);
    setSelectedCcnCallId(ccnCallId);
    setSelectedData(callId);
  };
  const handleModelOpenPrimeContractorHelpModel = (callId, ccnCallId) => {
    setSelectedCcnCallId(ccnCallId);
    setSelectedData(callId);
    setModelPrimeContractorHelp(true);
  };
  const handleModelClose = () => setModelOpen(false);
  const handleModelCloseViewPlan = () => setModdelOpenViewPlan(false);
  const handleModelCloeseOpenOptIN = () => {
    setModelOpenOptIN(false);
  };
  const handleModelCloeseSeeRecords = () => setModelSeeRecords(false);
  const handleModelCloeseAdvertiseForHelp = () => {
    setModelAdvertiseForHelp(false);
  };

  const handleModelCloesePrimeContractorHelp = () =>
    setModelPrimeContractorHelp(false);

  //   const handleAPIcall = () => {
  //     //setAPICAll(true);
  //   };

  const addFav = (ccn_call_id, favorite) => {
    setFavloader(true);
    const payload = {
      project_id: ccn_call_id,
      type: "DOT",
      action: favorite,
      state_id: selectedState?.value || storedState?.value,
    };

    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_FAVORITE}`,
      payload
    )
      .then((response) => {
        setFavloader(false);
        toast.success(response.data?.message);
        handleAPIcall();
      })
      .catch((error) => {
        toast.error(error?.message);
        setFavloader(false);
      });
  };

  return (
    <>
      <Modal
        size="xl"
        show={open}
        onHide={handleModalClose}
        centered
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton onClick={handleModalClose}>
          <Modal.Title id="example-custom-modal-styling-title centered">
            Project Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {type === "DOT" ? (
            !favloader ? (
              <ul className="list-group py-3">
                <li
                  className="list-group-item py-3 mb-3 bg-light border border-1 rounded-0 cursor-pointer"
                  key={data?.ccn_call_id}
                >
                  <div className="d-md-flex justify-content-between align-items-start">
                    <div className="me-auto mb-2">
                      <span className="fw-bold point-22">
                        {data?.county} &nbsp;
                      </span>
                      <span className="point-22 text-black-50 fw-light mb-2">
                        {data?.favorites === "0" ? (
                          <i
                            className="bi bi-star fs-6"
                            onClick={() => addFav(data?.id, data?.favorites)}
                          ></i>
                        ) : (
                          <img
                            src={favoriteImg}
                            alt="fav"
                            onClick={() => addFav(data?.id, data?.favorites)}
                          />
                        )}
                      </span>
                    </div>
                  </div>
                  <p className="lh-lg">
                    <span className="fw-bold">Call:</span> {data?.call_order}
                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                      &nbsp;|&nbsp;
                    </span>
                    <br className="d-block d-md-none" />
                    <span
                      className="fw-bold text-decoration-underline"
                      onClick={() => handleModelOpen(data?.callid)}
                    >
                      List of Bid Items
                    </span>
                    <span className="text-danger fw-bolder">&nbsp;|&nbsp;</span>
                    {data?.bidderDataAvailable > 0 ? (
                      <span
                        className="fw-bold text-decoration-underline"
                        onClick={() => handleModelOpenViewPlan(data?.callid)}
                      >
                        View Plan Holders
                      </span>
                    ) : (
                      <span className="fw-bold text-decoration-underline text-secondary">
                        View Plan Holders
                      </span>
                    )}
                    <br />
                    <span className="fw-bold">Description : </span>
                    {data?.Ldescription} <br />
                    {!data?.flag_optin ? (
                      <span
                        className="fw-bold text-decoration-underline text-secondary view-link"
                        onClick={() =>
                          handleModelOpenOptIN(data?.callid, data?.id)
                        }
                      >
                        Subs/Suppliers: Opt In
                      </span>
                    ) : (
                      <span className="fw-bold text-secondary text-decoration-underline">
                        Subs/Suppliers: Opt In
                      </span>
                    )}
                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                      &nbsp;|&nbsp;
                    </span>
                    <br className="d-block d-md-none" />
                    <span
                      className="text-decoration-underline text-secondary view-link"
                      onClick={() =>
                        handleModelOpenSeeRecords(data?.callid, data?.id)
                      }
                    >
                      See <span className="fw-bold">{data?.count_optin}</span>{" "}
                      Opt-in Records
                    </span>
                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                      &nbsp;|&nbsp;
                    </span>
                    <br className="d-block d-md-none" />
                    {!data?.flag_prime_advertise ? (
                      <span
                        className="fw-bold text-decoration-underline text-secondary view-link"
                        onClick={() =>
                          handleModelOpenAdvertiseForHelp(
                            data?.callid,
                            data?.id
                          )
                        }
                      >
                        &nbsp;Primes: Advertise for help
                      </span>
                    ) : (
                      <span className="fw-bold text-secondary">
                        &nbsp;Primes: Advertise for help
                      </span>
                    )}
                    <span className="text-danger fw-bolder d-none d-md-inline-block ">
                      &nbsp;|&nbsp;
                    </span>
                    <br className="d-block d-md-none" />
                    <span className="fw-bold ">
                      {data?.count_prime_advertise || 0}
                    </span>{" "}
                    <span
                      className="text-decoration-underline text-secondary view-link"
                      onClick={() =>
                        handleModelOpenPrimeContractorHelpModel(
                          data?.callid,
                          data?.id
                        )
                      }
                    >
                      Prime contractors looking for help
                    </span>
                  </p>
                </li>
              </ul>
            ) : (
              <div className="loader">
                <img src={loader} alt="loading" />
              </div>
            )
          ) : (
            <form>
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label
                    htmlFor="first_name"
                    className="form-label fw-semibold"
                  >
                    First Name
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="First name"
                    aria-label="First name"
                    name="first_name"
                    readOnly={true}
                    value={formData.first_name}
                    isReadOnly={true}
                    disabled
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="last_name" className="form-label fw-semibold">
                    Last Name
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="Last name"
                    aria-label="Last name"
                    name="last_name"
                    readOnly={true}
                    value={formData.last_name}
                    isReadOnly={true}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="email" className="form-label fw-semibold">
                    Email
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="Email"
                    aria-label="Email"
                    name="email"
                    readOnly={true}
                    value={formData.email}
                    isReadOnly={true}
                    disabled
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label
                    htmlFor="phone_number"
                    className="form-label fw-semibold"
                  >
                    Phone Number
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="Phone Number"
                    aria-label="Phone Number"
                    name="phone_number"
                    readOnly={true}
                    value={formData.phone_number}
                    isReadOnly={true}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label
                    htmlFor="project_title"
                    className="form-label fw-semibold"
                  >
                    Deadline Date for submitting quotes
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="DBE Goal%"
                    name="dbe_goal"
                    aria-label="DBE Goal%"
                    value={
                      formData.date_submitting
                        ? parseDateFromString(formData.date_submitting)
                        : null
                    }
                    ///   isReadOnly={true}
                    disabled
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label
                    htmlFor="project_title"
                    className="form-label fw-semibold"
                  >
                    DBE Goal%
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="DBE Goal%"
                    name="dbe_goal"
                    aria-label="DBE Goal%"
                    value={formData.dbe_goal}
                    isReadOnly={true}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <label
                    htmlFor="project_title"
                    className="form-label fw-semibold"
                  >
                    Project Title
                  </label>

                  <input
                    type="text"
                    className="form-control border border-secondary rounded-0"
                    placeholder="Project Title"
                    aria-label="Project Title"
                    name="project_title"
                    value={formData.project_title}
                    isReadOnly={true}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <label
                    htmlFor="project_description"
                    className="form-label fw-semibold"
                  >
                    Project Description
                  </label>

                  <textarea
                    className="form-control border border-secondary rounded-0"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder="Project Description"
                    name="project_description"
                    value={formData.project_description}
                    isReadOnly={true}
                    disabled
                  ></textarea>
                </div>
              </div>
              <div className="row">
                {/* Work Type Filter */}

                <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="worktypes" className="form-label fw-semibold">
                    Work Types
                  </label>
                  <WorkTypeFilter
                    borderTrue={true}
                    ismultiple={true}
                    preSelectedValues={formData.worktypes}
                    isdisabled={true}
                  />
                </div>

                {/* Conditional Inputs Based on Active Tab */}
                {/* State Selection */}
                {null && data.page_type === "STATE" && (
                  <>
                    <div className="col-12 col-md-6 mb-3">
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                        })}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: "#9FAFCA",
                            borderWidth: "3px",
                            "&:hover": {
                              borderColor: "#2684FF",
                            },
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "#a71e1e",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#6c757d",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#9FAFCA"
                              : "white",
                            color: state.isSelected ? "white" : "black",
                            "&:hover": {
                              backgroundColor: "#9FAFCA",
                              color: "white",
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            borderRadius: 0,
                          }),
                        }}
                        options={StateListFromLocalStorage}
                        value={selectedState || null}
                        name="state_id"
                        placeholder="Select State type..."
                        isSearchable
                        isdisabled={true}
                      />
                    </div>
                  </>
                )}

                {/* County Selection */}
                {null && data.page_type === "COUNTY" && (
                  <>
                    <div className="col-12 col-md-6 mb-3">
                      <CountryFilter borderTrue={true} isdisabled={true} />
                    </div>
                  </>
                )}

                {data.page_type !== "DESIGN_BUILD" && (
                  <>
                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="city" className="form-label fw-semibold">
                        City
                      </label>
                      <CityFilter
                        borderTrue={true}
                        preSelectedCity={formData.city}
                        isDisabled={true}
                      />
                    </div>
                  </>
                )}

                {data.page_type === "DESIGN_BUILD" && (
                  <>
                    <div className="col-12 col-md-6 mb-3">
                      <label
                        htmlFor="DESIGN_BUILD"
                        className="form-label fw-semibold"
                      >
                        Design Build Sub Category
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                        })}
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: "#9FAFCA",
                            borderWidth: "3px",
                            "&:hover": {
                              borderColor: "#2684FF",
                            },
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "#a71e1e",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#6c757d",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#9FAFCA"
                              : "white",
                            color: state.isSelected ? "white" : "black",
                            "&:hover": {
                              backgroundColor: "#9FAFCA",
                              color: "white",
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            borderRadius: 0,
                          }),
                        }}
                        options={design_build_category_options}
                        value={
                          design_build_category_options.find(
                            (option) =>
                              option.value === formData.design_build_category
                          ) || null
                        } // ✅ Pre-selects the correct value
                        name="design_build_category"
                        placeholder="Select Category Type"
                        isSearchable
                         isDisabled={true}
                      />
                    </div>
                  </>
                )}

                {/* File Input */}
                <div className="col-12 col-md-6 mb-3">
                  {formData.download_url ? (
                    <a
                      className="btn btn-secondary rounded-5 fw-semibold text-uppercase point-18 d-flex align-items-center justify-content-center"
                      href={formData.download_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Scope of Work
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
          )}
          {modelOpen && (
            <ListOfBidModel
              open={modelOpen}
              handleClose={handleModelClose}
              callId={selectedData}
            />
          )}
          {modelOpenViewPlan && (
            <ViewPlanHolderModel
              open={modelOpenViewPlan}
              handleClose={handleModelCloseViewPlan}
              callId={selectedData}
            />
          )}
          {modelOpenOptIN && (
            <OptInModel
              open={modelOpenOptIN}
              ccnCallId={selectedCcnCallId}
              callId={selectedData}
              handleClose={handleModelCloeseOpenOptIN}
              handleAPIcall={handleAPIcall}
              type="DOT"
              endPoint={process.env.REACT_APP_GET_ADD_OPTIN}
            />
          )}
          {modelSeeRecords && (
            <SeeRecordsModel
              open={modelSeeRecords}
              ccnCallId={selectedCcnCallId}
              callId={selectedData}
              handleClose={handleModelCloeseSeeRecords}
              //   handleAPIcall={handleAPIcall}
              endPoint={process.env.REACT_APP_GET_GET_OPTIN}
              type="DOT"
            />
          )}
          {modelAdvertiseForHelp && (
            <AdvertiseForHelpModel
              open={modelAdvertiseForHelp}
              handleClose={handleModelCloeseAdvertiseForHelp}
              callId={selectedData}
              ccnCallId={selectedCcnCallId}
              handleAPIcall={handleAPIcall}
              endPoint={process.env.REACT_APP_GET_ADD_ADVERTISE_FOR_HELP}
              type="DOT"
            />
          )}
          {PrimeContractorHelp && (
            <PrimeContractorHelpModel
              open={PrimeContractorHelp}
              callId={selectedData}
              ccnCallId={selectedCcnCallId}
              handleClose={handleModelCloesePrimeContractorHelp}
              endPoint={process.env.REACT_APP_GET_PRIME_ADVERTISE}
              type="DOT"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
